<template>
  <sui-modal class="wrapper" v-model="visible" size="small" :closable="false" :style="{zIndex}">
    <sui-modal-header class="header">
      Invite member
    </sui-modal-header>
    <sui-modal-content style="position: relative;">
      <sui-form warning :error="hasApiErrors" :loading="loading" @submit.prevent="submit()" v-if="entity">
        <FormMember v-model="entity" mode="creating" />
        <sui-message error>
          {{apiErrors}}
        </sui-message>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions>
      <div class="ui buttons">
        <sui-button icon="check" label-position="left" color="green" :disabled="loading || hasEntityErrors" @click="submit()" data-goal="CREATE_MEMBER_TRY">Send invite</sui-button>
        <sui-button icon="ban" label-position="right" color="red" @click="cancel()">Cancel</sui-button>
      </div>
    </sui-modal-actions>
    <sui-dimmer class="dimmer" :active="success" inverted>
      <h2 class="ui icon header">
        <i class="green check circle icon" />
        Success
      </h2>
    </sui-dimmer>
  </sui-modal>
</template>

<script>
  import ModalForm from '@/mixins/ModalForm'
  import FormMember from '@/components/forms/Member'
  import utils from '@/utils'

  export default {
    name: 'ModalCreateMember',
    mixins: [
      ModalForm,
    ],
    components: {
      FormMember,
    },
    methods: {
      open() {
        this.visible = true
        this.entity = {}
      },
      onSuccess(data) {
        // TODO: this is fallback: add email data which absent in socket event "create"
        this.$store.commit('updateEntity', {...data, target: 'member'})
        this.close()
        utils.reachGoal('CREATE_MEMBER_SUCCESS')
      },
      onFail() {
        utils.reachGoal('CREATE_MEMBER_FAIL')
      },
    },
    created() {
      this.$modals.createMember = this
    },
  }
</script>
